import { render, staticRenderFns } from "./ed-class-subject-placeholder-item.component.vue?vue&type=template&id=b1887a3a&scoped=true&"
import script from "./ed-class-subject-placeholder-item.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-subject-placeholder-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-subject-placeholder-item.component.scss?vue&type=style&index=0&id=b1887a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1887a3a",
  null
  
)

export default component.exports